module.exports = "<div class=\"envelope\">\r\n    <div>\r\n        <div class=\"form-group envelope__title\">\r\n            <h1>{{forbiddenPageTitle}}</h1>\r\n            <p>{{forbiddenDescription}}</p>\r\n        </div>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/templates/common/forbiddenView.component.html
// module id = 457
// module chunks = 0